import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { useContentOverflow } from '../../../../../../hooks'
import { Avatar, AVATAR_HEIGHT_40 } from '../../../../../Avatar'
import { FloatingTooltip } from '../../../../../Floating'
import Text from '../../../../../Text'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import {
  getApplicantIdentityAvatarProps,
  getApplicantIdentityMaskedNotice,
  getApplicantIdentityNameValue,
} from '../ApplicantIdentityWidget.utils'

import * as styles from './ApplicantIdentityWidgetName.module.css'

function ApplicantIdentityWidgetName() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const nameValue = getApplicantIdentityNameValue({ applicantData, t })

  return (
    <>
      <Text isSecondary className={styles.label}>
        {t('RentalPortal.ApplicantProfileIdentityNameLabelKey')}
      </Text>
      <div className={styles.content}>
        <FloatingTooltip
          content={getApplicantIdentityMaskedNotice({ applicantData, t })}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Avatar
            {...getApplicantIdentityAvatarProps(applicantData)}
            className={styles.avatar}
            size={AVATAR_HEIGHT_40}
          />
        </FloatingTooltip>
        <FloatingTooltip
          content={nameValue}
          disabled={!overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Text className={styles.value} ref={setContentOverflowRef}>
            {nameValue}
          </Text>
        </FloatingTooltip>
      </div>
    </>
  )
}

export default ApplicantIdentityWidgetName
